export var getLoyaltyStorage = function getLoyaltyStorage() {
  var storage = typeof window !== "undefined" ? JSON.parse(window.sessionStorage.getItem("persist:cb-ds")) : {};
  var loyaltyStorage = (storage === null || storage === void 0 ? void 0 : storage.loyalty) ? JSON.parse(storage.loyalty) : {};
  return loyaltyStorage;
};